import React from 'react';
import { Box, Typography, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { Globe, Trash2, ExternalLink, CheckCircle } from 'react-feather';
import UniversalList, { UniversalListItem } from '../components/UniversalList';
import { StatusChip, ItemTitle } from '../components/CommonStyles';

function TrainedWebsites({ websites, onDelete }) {
    if (!websites || websites.length === 0) {
        return null;
    }

    const renderWebsiteItem = (site) => (
        <UniversalListItem
            key={site.id}
            secondaryAction={
                <IconButton edge="end" size="small" onClick={() => onDelete(site)} sx={{ color: '#ef4444' }}>
                    <Trash2 size={16} />
                </IconButton>
            }
        >
            <ListItemIcon sx={{ minWidth: '40px' }}>
                <Globe size={20} color="#3b82f6" />
            </ListItemIcon>
            <ListItemText
                primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <ItemTitle title={site.original_name}>
                            {site.original_name}
                        </ItemTitle>
                        <StatusChip
                            icon={<CheckCircle />}
                            label="Trained"
                            size="small"
                        />
                        <IconButton
                            size="small"
                            href={site.original_name}
                            target="_blank"
                            sx={{ color: '#94a3b8', padding: '4px' }}
                        >
                            <ExternalLink size={14} />
                        </IconButton>
                    </Box>
                }
                secondary={
                    <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Added {new Date(site.created_at).toLocaleDateString()} • {site.size ? `${Math.round(site.size / 1024)} KB` : 'Unknown size'}
                    </Typography>
                }
            />
        </UniversalListItem>
    );

    return (
        <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
                Trained Websites ({websites.length})
            </Typography>
            <UniversalList
                items={websites}
                renderItem={renderWebsiteItem}
            />
        </Box>
    );
}

export default TrainedWebsites;
